/**
 * Kí hiệu âm
 */
export default {
    '(n)': 0,
    '-n': 1,
    '- n': 2,
    'n-': 3,
    'n -': 4
  }